'use strict';

var _ = require('lodash');

/**
 * Market Analysis - Market Product tab - Grid
 */
var MarketProductGroupGridTransformerFactory = function MarketProductGroupGridTransformerFactory($filter, MarketProductGroupTransformer, bookingsIntakeTransformationService, mergeScenarioDataService, effectiveValueService, momentService, hepService, classIndicesService, marketLiveDataService, metricReferenceDataService, fcrService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function MarketProductGroupGridTransformer() {
    MarketProductGroupTransformer.call(this, 'market-product-group-analysis', 1);
  }
  function setLastRefreshTime(timeStamp) {
    if (timeStamp) {
      marketLiveDataService.setLastRefreshTime('market-product-group-analysis', momentService.of(timeStamp, momentService.FIELD.EVENT_TIME_STAMP));
    }
  }
  MarketProductGroupGridTransformer.prototype = Object.create(MarketProductGroupTransformer.prototype);
  MarketProductGroupGridTransformer.constructor = MarketProductGroupGridTransformer;
  MarketProductGroupGridTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  MarketProductGroupGridTransformer.prototype.isCacheable = function () {
    return true;
  };
  MarketProductGroupGridTransformer.prototype.getCacheKey = function (metrics) {
    return this.sourceType + '-' + this.targetType + '-' + metrics.join('-');
  };
  MarketProductGroupGridTransformer.prototype.transform = function (data) {
    setLastRefreshTime(data.domain.timeStamp);
    var memoizedClassGroupIndices = _.memoize(classIndicesService.prepareClassGroupIndices);
    var memoizedMomentOfDepartureDate = _.memoize(getMomentOfDate);
    var memoizedMomentOfLastProcessedDate = _.memoize(getMomentOfDate);
    var memoizedDOWOfMoment = _.memoize(getDOWOfMoment, function (moment) {
      return moment.valueOf();
    });
    var memoizedYearMonthDayOfMoment = _.memoize(getYearMonthDayOfMoment, function (moment) {
      return moment.valueOf();
    });
    var alertThreshold = hepService.getSimpleHepProperties().ALERT_THRESHOLD;
    function setEffectiveValues(result, entry) {
      var effective = effectiveValueService.calculateAll(entry, 'market-product-group-analysis');
      _.assign(result, effective);
    }
    var transformData = function transformData(marketDemand) {
      var result = [];
      if (!marketDemand) {
        return;
      }
      for (var i = 0, length = marketDemand.length; i < length; i++) {
        var entry = marketDemand[i];
        var entryKey = entry.carrier + entry.market + entry.posName + entry.classGroup + entry.departureDate;
        var departureDate = memoizedMomentOfDepartureDate(entry.departureDate, momentService.FIELD.DEPARTURE_DATE);
        var lastProcessedDate = memoizedMomentOfLastProcessedDate(entry.eventTimeStamp, momentService.FIELD.EVENT_TIME_STAMP);
        var curDOW = memoizedDOWOfMoment(departureDate);
        var curYMD = memoizedYearMonthDayOfMoment(departureDate);
        var newEntry = {
          marketDemandId: entry.marketDemandId,
          referenceCurveMarketDemandId: entry.referenceCurveMarketDemandId,
          entryKey: entryKey,
          entity: entry.entity,
          scenarioName: entry.scenarioName,
          carrier: entry.carrier,
          origin: entry.origin,
          destination: entry.destination,
          classGroup: entry.classGroup,
          season: entry.season,
          seasonOverride: entry.userMappedSeasonOverride || entry.userRegularSeasonOverride,
          dowGroup: entry.dowGroup,
          market: entry.market,
          posName: entry.posName,
          availabilityCurrent: entry.currentAvailability,
          lowestClassAvailability: entry.lowestClass,
          lowestClassFare: entry.lowestFare,
          daysToDeparture: entry.daysToDeparture,
          startRtpRegularRemainingDemandFC: _.isNil(entry.startRtpRegularRemainingDemandFC) ? entry.daysToDeparture : entry.startRtpRegularRemainingDemandFC,
          startRtpMappedRemainingDemandFC: _.isNil(entry.startRtpMappedRemainingDemandFC) ? entry.daysToDeparture : entry.startRtpMappedRemainingDemandFC,
          regularRemainingDemandFC: entry.regularRemainingDemandFC,
          calculatedRegularRemainingDemandFC: entry.calculatedRegularRemainingDemandFC,
          userTypeRegularRemainingDemandFC: entry.userTypeRegularRemainingDemandFC,
          userValueRegularRemainingDemandFC: entry.userValueRegularRemainingDemandFC,
          regularRemainingDemandFCCV: entry.regularRemainingDemandFCCV,
          mappedRemainingDemandFCCV: entry.mappedRemainingDemandFCCV,
          regularRemainingDemandMWTP: entry.regularRemainingDemandMWTP,
          mappedRemainingDemandFC: entry.mappedRemainingDemandFC,
          calculatedMappedRemainingDemandFC: entry.calculatedMappedRemainingDemandFC,
          userTypeMappedRemainingDemandFC: entry.userTypeMappedRemainingDemandFC,
          userValueMappedRemainingDemandFC: entry.userValueMappedRemainingDemandFC,
          departureDate: curYMD,
          departureDateMoment: departureDate,
          departureDateMomentDDD: curDOW,
          lastProcessedDateMoment: lastProcessedDate,
          mappedProfileLevel: entry.mappedProfileLevel,
          regularProfileLevel: entry.regularProfileLevel,
          numberOfItineraries: entry.numberOfItineraries,
          appliedRules: entry.appliedRules,
          effectiveMappedSvcRemainingDemandFC: entry.effectiveMappedSvcRemainingDemandFC,
          effectiveRegularSvcRemainingDemandFC: entry.effectiveRegularSvcRemainingDemandFC,
          alerts: entry.alertScore,
          numberOfAlertRulesApplied: entry.numberOfAlertRulesApplied,
          alertThresholdExceeded: entry.alertScore > alertThreshold,
          eventTimeStamp: entry.eventTimeStamp,
          latestChanges: entry.latestChanges,
          appliedRulesNumber: entry.appliedRules.length,
          classGroupIndex: memoizedClassGroupIndices(fcrService.getClassGroupIndicesKey(departureDate, entry.market))[entry.classGroup]
        };
        var metricValues = metricReferenceDataService.getMetricsDataForGrid(entry, ['bookings', 'revenue', 'yield']);
        var entryWithMetrics = _.extend(newEntry, metricValues);
        bookingsIntakeTransformationService.calculateBookingsIntake(entryWithMetrics, entry);
        effectiveValueService.setDefaultTypes(entryWithMetrics);
        setEffectiveValues(entryWithMetrics, entry);
        result.push(entryWithMetrics);
      }
      return result;
    };
    var productionData = transformData(data.domain.flattenedAggregatedMarketDemand);
    var scenarioData = transformData(data.thirdDomain && data.thirdDomain.flattenedAggregatedMarketDemand || []);
    return mergeScenarioDataService.merge(productionData, scenarioData);
  };
  function getMomentOfDate(date, field) {
    return momentService.of(date, field);
  }
  function getDOWOfMoment(moment) {
    return rmMomentFormat(moment, 'DAY_OF_WEEK');
  }
  function getYearMonthDayOfMoment(moment) {
    return rmMomentFormat(moment, 'DATE_ISO');
  }
  return MarketProductGroupGridTransformer;
};
MarketProductGroupGridTransformerFactory.$inject = ['$filter', 'MarketProductGroupTransformerFactory', 'BookingsIntakeTransformationService', 'MergeScenarioDataService', 'CalculateEffectiveValueService', 'MomentService', 'HepService', 'ClassIndicesService', 'MarketLiveDataService', 'MetricReferenceDataService', 'FcrService'];
module.exports = MarketProductGroupGridTransformerFactory;